const getCompanyUsers = ({ auth: { companyUsers } }) => ({ companyUsers });

export default getCompanyUsers;
